<!--
 * @Description:线索客户的联系人信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-06 15:57:35
 * @LastEditors: cxh
-->
<template>
  <fbu
    v-if="appId === 'cos_fbu'"
    :tableId="tableIdByPath('contacts')"
    v-bind="$attrs"
    :permissionPage="permissionPage"
    ref="fbuRef"
  ></fbu>
  <lbu
    v-else-if="appId === 'cos_lbu'"
    v-bind="$attrs"
    :tableId="tableIdByPath('contacts')"
    :permissionPage="permissionPage"
    ref="lbuRef"
  ></lbu>
  <zbu
    v-else-if="appId === 'cos_zbu'"
    v-bind="$attrs"
    :tableId="tableIdByPath('contacts')"
    :permissionPage="permissionPage"
    ref="zbuRef"
  ></zbu>
  <ofbu
    v-else-if="appId === 'cos_ofbu'"
    v-bind="$attrs"
    :tableId="tableIdByPath('contacts')"
    :permissionPage="permissionPage"
    ref="ofbuRef"
  ></ofbu>
</template>
<script setup lang="ts">
import { ref, PropType } from 'vue'
import fbu from './fbu/index.vue'
import lbu from './lbu/index.vue'
import zbu from './zbu/index.vue'
import ofbu from './ofbu/index.vue'
import { tableIdByPath } from '@/utils'
const fbuRef = ref()
const lbuRef = ref()
const zbuRef = ref()
const ofbuRef = ref()
const props = defineProps({
  appId: {
    type: String,
    default: 'cos_fbu'
  },
  permissionPage: {
    type: Object as PropType<{
      edit: string
      del: string
    }>,
    default: () => {
      return {}
    }
  }
})

const refresh = (type?: 'add' | 'edit') => {
  switch (props.appId) {
    case 'cos_fbu':
      fbuRef.value.refresh(type)
      break
    case 'cos_lbu':
      lbuRef.value.refresh(type)
      break
    case 'cos_zbu':
      zbuRef.value.refresh(type)
      break
    case 'cos_ofbu':
      ofbuRef.value.refresh(type)
      break
  }
}
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default {
  name: 'TabsContacts'
}
</script>
